<table class="table table-striped ptp-grid-skeleton">
    <thead>
        <tr>
            @for (h of headers; track h) {
                <th>{{ h }}</th>
            }
        </tr>
    </thead>
    <tbody>
        @for (r of rowRange; track r) {
            <tr>
                @for (h of headers; track h) {
                    <td>
                        <nz-skeleton-element nzType="input" [nzActive]="true"></nz-skeleton-element>
                    </td>
                }
            </tr>
        }
    </tbody>
</table>
